<template>
  <v-app>
    <v-container>
      <div class="about text-center">
        <!-- <h1>2021 國際數學日 3.14</h1>
        <img width="50%" src="../assets/EmbeddedImage.png" /> -->
        <EmbeddedResult />
      </div>
    </v-container>
  </v-app>
</template>

<script>
// @ is an alias to /src
import EmbeddedResult from "@/components/Result.vue";
// 

export default {
  name: "Embedded",
  components: {
    EmbeddedResult,
  },
  mounted(){
      this.$vuetify.theme.dark = false;
  }
};
</script>
